import { toast } from "sonner"
import html2pdf from "html2pdf.js"

/**
 * Exports the content of an element to a PDF file using html2pdf.js
 */
export const exportReportAsPDF = (elementId: string, fileName: string = 'report') => {
  try {
    const element = document.getElementById(elementId)
    if (!element) {
      toast.error("Export failed", {
        description: "Could not find report content to export"
      })
      return
    }
    const fullFileName = `${fileName.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`
    html2pdf()
      .set({
        margin: 0.5,
        filename: fullFileName,
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
      })
      .from(element)
      .save()
      .then(() => {
        toast.success("Report exported successfully")
      })
      .catch(() => {
        toast.error("Export failed", {
          description: "There was an error exporting the report"
        })
      })
    return true
  } catch {
    toast.error("Export failed", {
      description: "There was an error exporting the report"
    })
    return false
  }
}
